module.exports = __webpack_public_path__ + "static/media/graduation-hat.e6e2a691.png";